import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ReactSelect from "react-select";
import { GetPropertyReport, GetPropertyReturnsList } from "../../Repository/Api";
import { imagepath } from "../../Repository/BaseUrl";
import { errorMsg } from "../Toastify";
const StaffPropertyReport = () => {
  const { first_name, desingation, department, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token
  const navigate = useNavigate();

  const [savedReport, setSavedReport] = useState({});

  const [apply, setApply] = useState({});
  const [word, setWord] = useState('');

  useEffect(() => {
    getSavedReport();
    getDownloadreport()
  }, []);
  const FinancialYearOptions = () => {
    const date = new Date()
    const isApril = date.getMonth() >= 3
    const currentYear1 = date.getFullYear();
    const currentYear = currentYear1 + 1;
    const startYear = 2024;
    const numberOfYears = currentYear - 2024
    const dummyyearOptions = [];
    for (let i = 0; i < numberOfYears; i++) {
      dummyyearOptions.push(startYear + i);
    }
    const yearOptions = dummyyearOptions.map((item) => ({
      label: `${item}-${item + 1}`,
      value: `${item}-${item + 1}`
    }));

    const finalData = isApril ? yearOptions : yearOptions?.pop()
    return finalData
  }

  const setData = (e, key) => {
    setApply({ ...apply, [key]: e });
  };
  const getSavedReport = async () => {
    const response = await GetPropertyReturnsList(token);
    if (response && response.statusCode === 200) {

      setSavedReport(response?.data);
    } else {
      errorMsg(response.message);
    }
  };

  const getDownloadreport = async () => {
    const response = await GetPropertyReport(token)
    if (response && response.statusCode === 200) {

      setWord(response?.data)
    } else {
      errorMsg(response.message);
    }
  }

  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <h6 className="headertext">
                  {first_name} - {desingation}
                </h6>
                <h6 className="subheadertext">{department}</h6>
              </div>
              <div className="col-lg-3">
                <div className="headeralign">
                  <a href={`${imagepath + word}`} download='PropertyReturnsDocument' target="_blank">
                    <button
                      className="requestbtn"
                    >
                      Download Document
                    </button>
                  </a>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="headeralign">
                  <button
                    className="requestbtn"
                    onClick={() => {
                      navigate("/app/upload/propertyreport");
                    }}
                  >
                    Upload Document
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="row">
            <div className="">
              <div className="graphbox">
                <h6 className="labeltitle">Property Returns Report</h6>
                <div className="row mt-3 align-items-end">
                  <div className="col-lg-4">
                    <label className="labeltext"> Academic Year *</label>
                    <ReactSelect
                      isMulti={false}
                      value={{
                        label: apply.academic_year,
                        value: apply.academic_year,
                      }}
                      onChange={(selectedOption) =>
                        setData(selectedOption.value, "academic_year")
                      }
                      options={FinancialYearOptions()}
                    />
                  </div>
                  <div className="col-lg-4">
                    <button className="requestbtn" onClick={getSavedReport}>Get Report</button>
                  </div>
                </div>
                <table className="table table-hover mt-5">
                  <thead>
                    <tr>
                      <th scope="col">Year</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {savedReport?.length > 0 ? (
                      savedReport &&
                      savedReport?.map((saved, index) => {


                        return (
                          <tr key={index}>
                            <td>{saved?.academic_year ? (saved?.academic_year + '-' + (saved?.academic_year + 1)) : "-"}</td>
                            <td>
                              {saved?.document_url !== ' ' ?
                                <div className="d-flex align-items-center justify-content-center">
                                  <a href={`${imagepath + saved?.document_url}`} target="_blank" download={saved?.name}>
                                    <span class="material-symbols-outlined" >
                                      download_2
                                    </span>
                                  </a>
                                </div>
                                : "-"}
                            </td>
                          </tr>
                        )
                      }

                      )
                    ) : (
                      <>
                        <tr>
                          <td colSpan={3}>
                            <div> No Data Found</div>
                          </td>

                        </tr>
                      </>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default StaffPropertyReport;
